import React from "react";
import { Box } from "@mui/material";
export default function MapLinearBar({ value, color, norot }) {
  return (
    <Box
      sx={{
        height: "6px",
        width: "100%",
        position: "relative",
        borderRadius: "3px",
        transform: norot ? "" : " rotateY(180deg)",
      }}
    >
      <Box
        sx={{
          background: "#F48706",
          boxShadow: " 1px 1px 6px #F4870626",
          width: value,
          height: "100%",
          borderRadius: "3px",
        }}
      ></Box>
      <Box
        sx={{
          borderRadius: "3px",
          width: "100%",
          position: "absolute",
          top: "0px",
          height: "100%",
        }}
      ></Box>
    </Box>
  );
}
